import { CircleDollarSign, Eye, Store, UserCircle2 } from 'lucide-react'
import { SegmentTabs } from '@/components/ui/page-toolbar'
import type { GestorDashboardSubTab } from '@/components/Gestores/gestorDashboardTypes'

const TABS = [
  { id: 'overview' as const, label: 'Visão Geral', icon: Eye },
  { id: 'collaborator' as const, label: 'Por Colaborador', shortLabel: 'Colaborador', icon: UserCircle2 },
  { id: 'clients' as const, label: 'Performance Clientes', shortLabel: 'Clientes', icon: Store },
  { id: 'financial' as const, label: 'Financeiro', icon: CircleDollarSign },
]

type Props = {
  value: GestorDashboardSubTab
  onChange: (value: GestorDashboardSubTab) => void
}

export function GestorDashboardSubTabs({ value, onChange }: Props) {
  return (
    <div className='flex justify-center'>
      <SegmentTabs
        value={value}
        onChange={onChange}
        tabs={TABS}
        ariaLabel='Visões do dashboard marketing'
        className='w-fit max-w-full flex-none'
      />
    </div>
  )
}
